import { v4 as uuid4 } from 'uuid';
import mime from 'mime-types';

export class UploadedFile {
    constructor(url = null, id = null, file = null, error = null,
                uploading = false, size= 0, serverSide = false, serverName = null) {
        this.id = id;
        this.url = url;
        this.file = file;
        this.error = error;
        this.uploading = uploading;
        this.size = size;
        this.uuid = uuid4();
        this.serverSide = serverSide;
        this.serverName = serverName || this.nameFallback();
    }

    nameFallback() {
        if (this.file) {
            return this.file.name
        }
        if (this.url) {
            let parts = this.url.split('/');
            return parts[parts.length - 1];
        }
        return this.uuid;
    }
    get name() {
        if (this.serverName) {
            return this.serverName
        }
        return this.nameFallback()
    }
    get mime() {
        if (this.serverSide && this.url) {
            return mime.lookup(this.url)
        }
        return this.file.type;
    }
    get isImage() {
        return this.mime.startsWith('image')
    }
    getUrl() {
        if (this.url) { return this.url }
        return URL.createObjectURL(this.file)
    }
    getMediaUrl() {
        const url = this.getUrl();
        if (this.serverSide) {
            return process.env.VUE_APP_DOMAIN + url
        }
        return url
    }
}
